import {ExpansionProps} from '../types';
import {updateEnvForLocalizationLocalesItem} from './localization';
import {replaceLocaleLinkProperties} from './replaceLocaleLinkProperties';
import {addDynBindEmptyClass} from './addDynBindEmptyClass';
import {replaceRichTextInnerHTMLProp} from './replaceRichTextInnerHTMLProp';
import {replaceRichTextCollectionTemplatePageHrefs} from './replaceRichTextCollectionTemplatePageHrefs';
import {addSlotOverlay} from './addSlotOverlay';
import {RenderContext} from '../RenderContext';
import {Environment} from '@packages/systems/core-constants';

export const transformExpansionProps = <T extends ExpansionProps>(
  props: T,
  collectionIdToPageIdMap: RenderContext['collectionIdToPageIdMap'],
  runtimeEnvironment: Environment
): T =>
  addDynBindEmptyClass(
    replaceLocaleLinkProperties(
      replaceRichTextInnerHTMLProp(
        replaceRichTextCollectionTemplatePageHrefs(
          addSlotOverlay(props, runtimeEnvironment),
          collectionIdToPageIdMap,
          runtimeEnvironment
        ),
        runtimeEnvironment
      )
    ),
    runtimeEnvironment
  );

export const transformDataEnv = updateEnvForLocalizationLocalesItem;
